# Obecna nastaveni pro grafy

CHART_SETTINGS =
    transition: 700
